import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    dialogContent: {
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: '10%',
        paddingRight: '10%',
        padding: 0,
        minWidth: '300px'
    },
    dialogPaper: {
        minWidth: '25%'
    },
    dialogTitle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingBottom: '5px'
    },
    textField: {
        marginTop: '16px',
    },
    rightIcon: {
        marginLeft: '8px',
        fontSize: 20
    },
    mailAddText: {
        width: 'calc(100% - 45px)',
        marginRight: '5px'
    }
}));

export default useStyles;
